import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin') {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

// Public API
export const submitLead = (data) => API.post('/leads', data);
export const submitContact = (data) => API.post('/contact', data);
export const submitDemoRequest = (data) => API.post('/demo-request', data);
export const sendChatMessage = (data) => API.post('/chat', data);
export const getPublicContent = () => API.get('/content');

// Admin API
export const adminLogin = (data) => API.post('/admin/login', data);
export const adminSetup = (data) => API.post('/admin/setup', data);
export const getAdminProfile = () => API.get('/admin/me');
export const getLeads = (params) => API.get('/admin/leads', { params });
export const getLead = (id) => API.get(`/admin/leads/${id}`);
export const updateLead = (id, data) => API.patch(`/admin/leads/${id}`, data);
export const deleteLead = (id) => API.delete(`/admin/leads/${id}`);
export const getStats = () => API.get('/admin/stats');
export const getChatSessions = () => API.get('/admin/chat-sessions');
export const getContent = () => API.get('/admin/content');
export const createContent = (data) => API.post('/admin/content', data);
export const updateContent = (id, data) => API.put(`/admin/content/${id}`, data);
export const deleteContent = (id) => API.delete(`/admin/content/${id}`);
